module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/shop.52bee31c.png";